import moment from 'moment'
import React from 'react'
import { Button, Card, Drawer, Form, Icon, notification, Row } from 'antd'
import _ from 'lodash'

import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { hideLoader, showLoader } from '../../modules/actions'
import Request, { LAPI_URL } from '../../request'
import { connect } from 'react-redux'
import StudentInfo from '../StudentInfo'

@Form.create()
class ListFollowUps extends React.Component {
    state = {
        visible: true,
        registrationDesk: '',
        inquiryId: '',
        loading: false,
        discount: 0,
        payment: 0,
        totalPayment: 0
    }
    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        e.preventDefault()
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData)
                values._id = this.state.inquiryId
                if (this.state.totalPayment <= 0) {
                    notification.error({
                        message: 'Valid amount.',
                        description: 'Please enter valid amount.'
                    })
                    return
                }
                if (values.balance < this.state.totalPayment) {
                    notification.error({
                        message: 'Valid amount.',
                        description: 'Please enter valid amount.'
                    })
                    return
                }

                dispatch(showLoader())
                values.countryId = this.state.registrationDesk.countryId
                this.setState({ loading: true });
                let x = await Request.visaPayment(values)
                this.setState({ loading: false });

                dispatch(hideLoader())

                if (!x.error) {
                    notification.success({
                        message: 'Success',
                        description: x.msg
                    })

                    this.onClose()

                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    componentDidMount() {
        const { form, inquiryObj } = this.props
        this.setState({
            registrationDesk: inquiryObj.registrationDesk,
            record: inquiryObj.record,
            inquiryId: inquiryObj._id
        })

        setTimeout(() => {
            form.setFieldsValue({
                total: this.state.registrationDesk.total,
                paid: this.state.registrationDesk.paid,
                balance: this.state.registrationDesk.balance,
                currentPayment: 0,
                currentBalance: this.state.registrationDesk.balance,
                receipt: this.state.registrationDesk.receipt,
                dateOfReciept: this.state.registrationDesk.dateOfReciept ? moment(this.state.registrationDesk.dateOfReciept) : null
            })
        }, 500)

    }

    calculatePayment() {
        let balance = this.state.registrationDesk.balance
        let payment = this.props.form.getFieldValue('payment')
        let discount = this.props.form.getFieldValue('discount')
        let totalPaid = 0
        if (payment) {
            totalPaid = totalPaid + parseFloat(payment)
        }
        if (discount) {
            totalPaid = totalPaid + parseFloat(discount)
        }
        let currentBalance = parseFloat(balance) - parseFloat(totalPaid)
        this.setState({
            totalPayment: totalPaid
        })
        if (currentBalance < 0) {
            this.props.form.setFieldsValue({ 'currentBalance': balance })
        } else {
            this.props.form.setFieldsValue({ 'currentBalance': currentBalance })
        }

    }

    render() {
        const {
            form: { getFieldDecorator }
        } = this.props

        const inputFields = {
            fields: [
                {
                    label: 'Total Amount ',
                    key: 'total',
                    type: 'number',
                    disabled: true
                },
                {
                    label: 'Payment done on Registration desk',
                    key: 'paid',
                    type: 'number',
                    disabled: true
                },
                {
                    label: 'Previous Balance',
                    key: 'balance',
                    type: 'number',
                    disabled: true
                },
                {
                    label: 'Current Payment',
                    key: 'payment',
                    required: true,
                    type: 'number',
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ 'payment': v })
                        setTimeout(() => {
                            this.calculatePayment()
                        }, 1000)
                    }
                },
                {
                    label: 'Discount',
                    key: 'discount',
                    type: 'number',
                    onChange: (v) => {
                        this.props.form.setFieldsValue({ 'discount': v })
                        setTimeout(() => {
                            this.calculatePayment()
                        }, 1000)
                    }
                },
                {
                    label: 'Reason For Discount',
                    key: 'discountReason',
                    disabled: this.props.form.getFieldValue('discount') > 0 ? false : true,
                    required: this.props.form.getFieldValue('discount') > 0 ? true : false
                },
                {
                    label: 'Discount Proof (If Any)',
                    key: 'discountFile',
                    type: 'file',
                    hidden: this.props.form.getFieldValue('discount') > 0 ? false : true,
                },
                {
                    label: 'Current Balance',
                    key: 'currentBalance',
                    type: 'number',
                    disabled: true
                },
                {
                    label: 'Generate Receipt',
                    key: 'generateReceipt',
                    type: 'select',
                    options: ['Yes', 'No'],
                    onChange: v => {
                        this.props.form.setFieldsValue({ generateReceipt: v })
                    }
                },
                { label: 'Receipt No', key: 'receipt', extra: <i>(Mark 0 if receipt not issued.)</i> },
                {
                    label: 'Apply GST',
                    key: 'ApplyGST',
                    required: true,
                    type: 'select',
                    options: [
                        'Yes',
                        'No'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({ ApplyGST: v })
                    }
                },
                {
                    label: 'Payment Type',
                    key: 'paymentType',
                    required: true,
                    type: 'select',
                    options: [
                        'Cash',
                        'Transfer'
                    ],
                    onChange: v => {
                        this.props.form.setFieldsValue({ paymentType: v })
                    }
                },
                { label: 'Date of Receipt', key: 'dateOfReciept', required: true, type: 'date' },
                { label: 'Remarks', key: 'remarks', required: true, type: 'textarea' }
            ]
        }

        return (
            <Drawer
                title={
                    <div>
                        Payment {' '}
                        <button onClick={this.onClose} style={{ float: 'right' }}>
                            <Icon type={'cross'} />
                        </button>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    {
                        this.state.record ? <Card bordered={true} style={{ marginBottom: 10 }}>
                            <StudentInfo
                                info={this.state.record}

                            />
                        </Card> : null
                    }

                    <Form onSubmit={this.handleSubmit} hideRequiredMark>
                        <GetAllFormFields
                            inputSchema={inputFields}
                            apiurl={LAPI_URL}
                            getFieldDecorator={getFieldDecorator}
                        />
                        <Form.Item>
                            <Row>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    loading={this.state.loading}
                                >
                                    SAVE
                                </Button>
                            </Row>
                        </Form.Item>
                    </Form>
                </Card>


            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListFollowUps)
